import { useState } from "react";
import VerifyShell from "./VerifyShell";
import InputPasswordComp from "../../components/inputs/input/InputPasswordComp";
import flyingEduman from '../../assets/images/eduman+eduwoman.svg';
import GreenButton from "../../components/buttons/GreenButton";
import RedButton from "../../components/buttons/RedButton";
import { Link, useNavigate, useParams } from "react-router-dom";
import PixelEdumanLoader from "../../components/loading/PixelEdumanLoader";

// import "../../assets/css/pages/"


const VerifiyResetPassword = ({pageValid, setPageValid, loading, setLoading, endpoint = "/setPassword", setIgnore}) => {
    const [tokenData, setTokenData] = useState({});
    const [contentForm, setContentForm] = useState({
        newPassword: "",
        reNewPassword: ""
    });

    const [message, setMessage] = useState(false);

    const navigate = useNavigate();
    const params = useParams();

    const resetPasswordUpdateFuntion = (e, field, value) => {
        if(field) {
            setContentForm(prev => ({
                ...prev,
                [field]: value
            }));
        }
    };

    const returnLogin = () => {
        navigate("../../../");
    };

    const submitResetPassword = (e) => {
        e.preventDefault()
        setLoading(true);
        setMessage(false);
        const { protocol, hostname} = window.location;

        fetch(`${protocol}//${hostname}${(hostname === "localhost") ? ":3001" : ""}/routes/api/verification/verify${endpoint}/finalize`, {
            method: "POST",
            headers: {
                Accepts: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({token: params.token, data: contentForm})
        })
        .then(res => {
            if(res.ok) {
                return res.json();
            }

            throw new Error(res);
        })
        .then(data => {
            setLoading(false);
            
            if(data?.type === "success") {
                setMessage({message: data.message, type: data.type, finished: true});
                return;
            }

            setMessage({message: data.message, type: data.type});
        })
        .catch(error => {
            setMessage({message: "Something went wrong. Please try again in a few moments.", type: "error"});
            setLoading(false);
        });
    };

    return (
        <>
            <VerifyShell setLoading={setLoading} setPageValid={setPageValid} endpoint={endpoint} setIgnore={setIgnore} setMessage={setMessage} setData={setTokenData} />
            {   pageValid ?
                <>
                    {   (tokenData?.expired) ?
                        <>
                            <div className="flex flexCenter">
                                <div className="flex flexColumn flexCenter verify-container">
                                    <img alt="Eduhero Mascot Flying" className="verify-flyingEduman" src={flyingEduman} />
                                    <div className="verify-message-container textAlignCenter">
                                        {tokenData.message}
                                        <br />
                                        <Link to={"../../../"} className="verify-return">Return To Login</Link>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            {   (!message?.finished) ?
                                <div className="flex flexCenter">
                                    {   tokenData?.type === "success" &&
                                        <>
                                            {   (loading) &&
                                                <>
                                                    <PixelEdumanLoader isAbsolute={true} message={"Verifying"} />
                                                </>
                                            }
                                            <form name="resetPassword" id="resetPassword" type="submit" className="flex flexColumn flexCenter verify-container" onSubmit={submitResetPassword}>
                                                <img alt="Eduhero Mascot Flying" className="verify-flyingEduman" src={flyingEduman} />
                                                <div className="blackBox verify-message-container">
                                                    {   message &&
                                                        <>
                                                            <div className={"textAlignCenter " + (message?.type === "error" ? "errorBox" : "")}>
                                                                {message.message}
                                                            </div>
                                                        </>
                                                    }
                                                    <label name={"newPassword"}>New Password: </label>
                                                    <InputPasswordComp field={"newPassword"} form={"resetPassword"} updateFunction={resetPasswordUpdateFuntion} required={true} name={"newPassword"} />

                                                    <label name={"newPassword"}>Re-Enter New Password: </label>
                                                    <InputPasswordComp field={"reNewPassword"} form={"resetPassword"} updateFunction={resetPasswordUpdateFuntion} required={true} name={"reNewPassword"} />

                                                    {/* button needed for "enter" key submission while focused on input field */}
                                                    <button type="submit" hidden></button>

                                                    <div className="flex flexJustifySpaceBetween flexAlignCenter">
                                                        <RedButton fancyBorder={false} onClickDo={returnLogin}>Cancel</RedButton>
                                                        <GreenButton fancyBorder={false} onClickDo={submitResetPassword}>Submit</GreenButton>
                                                    </div>
                                                </div>
                                            </form>
                                        </>
                                    }
                                </div>
                                :
                                <>
                                    <div className="flex flexCenter">
                                        <div className="flex flexColumn flexCenter verify-container">
                                            <img alt="Eduhero Mascot Flying" className="verify-flyingEduman" src={flyingEduman} />
                                            <div className="verify-message-container textAlignCenter">
                                                {message.message}
                                                <br />
                                                <Link to={"../../../"} className="verify-return">Return To Login</Link>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </>
                    }
                </>
                :
                <>
                    <div>
                        We were unable to verify your link at this time. Please refresh in a few moments.
                    </div>
                </>
            }
        </>
    );
};

export default VerifiyResetPassword;